/**
 * @generated SignedSource<<0b0163c59363b7f3db9002faccb05261>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AuthReason = "BAD_LEVEL" | "CREDENTIALS_REFUSED" | "INVALID_EMAIL" | "LINK_REFUSED" | "NAME_REQUIRED" | "NAME_TOO_LONG" | "NATIVE_LANGUAGE_IS_ENGLISH" | "PASSWORD_REFUSED" | "RESET_REQUESTED" | "SIGNUP_ACCEPTED" | "WEAK_PASSWORD" | "%future added value";
export type LinkViewVerifyEmailMutation$variables = {
  token: string;
};
export type LinkViewVerifyEmailMutation$data = {
  readonly verifyEmail: {
    readonly ok: boolean;
    readonly reason: AuthReason | null | undefined;
  };
};
export type LinkViewVerifyEmailMutation = {
  response: LinkViewVerifyEmailMutation$data;
  variables: LinkViewVerifyEmailMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "token",
        "variableName": "token"
      }
    ],
    "concreteType": "VerifyEmailPayload",
    "kind": "LinkedField",
    "name": "verifyEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reason",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LinkViewVerifyEmailMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "LinkViewVerifyEmailMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "f44a4040f581d154f36bbe50fb9f771c",
    "id": null,
    "metadata": {},
    "name": "LinkViewVerifyEmailMutation",
    "operationKind": "mutation",
    "text": "mutation LinkViewVerifyEmailMutation(\n  $token: String!\n) {\n  verifyEmail(token: $token) {\n    ok\n    reason\n  }\n}\n"
  }
};
})();

(node as any).hash = "e3cd08da688e8afeaa514d0e87c501ad";

export default node;
